import { render, staticRenderFns } from "./Dashboard_List.vue?vue&type=template&id=0e9edc2c&"
import script from "./Dashboard_List.vue?vue&type=script&lang=js&"
export * from "./Dashboard_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports